// source: pbtypes/gen/flag_util/flag_hoist_sub.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flag_util_format_type_pb = require('../../../pbtypes/gen/flag_util/format_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flag_util_format_type_pb);
var pbtypes_gen_flag_util_sub_type_pb = require('../../../pbtypes/gen/flag_util/sub_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flag_util_sub_type_pb);
goog.exportSymbol('proto.flag_util.FlagHoistSub', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flag_util.FlagHoistSub = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flag_util.FlagHoistSub.repeatedFields_, null);
};
goog.inherits(proto.flag_util.FlagHoistSub, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flag_util.FlagHoistSub.displayName = 'proto.flag_util.FlagHoistSub';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flag_util.FlagHoistSub.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flag_util.FlagHoistSub.prototype.toObject = function(opt_includeInstance) {
  return proto.flag_util.FlagHoistSub.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flag_util.FlagHoistSub} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.FlagHoistSub.toObject = function(includeInstance, msg) {
  var f, obj = {
lifetimeMs: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
format: jspb.Message.getFieldWithDefault(msg, 3, 0),
replyChannel: jspb.Message.getFieldWithDefault(msg, 4, ""),
flagNamesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flag_util.FlagHoistSub}
 */
proto.flag_util.FlagHoistSub.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flag_util.FlagHoistSub;
  return proto.flag_util.FlagHoistSub.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flag_util.FlagHoistSub} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flag_util.FlagHoistSub}
 */
proto.flag_util.FlagHoistSub.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setLifetimeMs(value);
      break;
    case 2:
      var value = /** @type {!proto.flag_util.SubType.Enum} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {!proto.flag_util.FormatType.Enum} */ (reader.readEnum());
      msg.setFormat(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReplyChannel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addFlagNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flag_util.FlagHoistSub.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flag_util.FlagHoistSub.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flag_util.FlagHoistSub} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flag_util.FlagHoistSub.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLifetimeMs();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getReplyChannel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFlagNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional sint64 lifetime_ms = 1;
 * @return {number}
 */
proto.flag_util.FlagHoistSub.prototype.getLifetimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.setLifetimeMs = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional SubType.Enum type = 2;
 * @return {!proto.flag_util.SubType.Enum}
 */
proto.flag_util.FlagHoistSub.prototype.getType = function() {
  return /** @type {!proto.flag_util.SubType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flag_util.SubType.Enum} value
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional FormatType.Enum format = 3;
 * @return {!proto.flag_util.FormatType.Enum}
 */
proto.flag_util.FlagHoistSub.prototype.getFormat = function() {
  return /** @type {!proto.flag_util.FormatType.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.flag_util.FormatType.Enum} value
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.setFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string reply_channel = 4;
 * @return {string}
 */
proto.flag_util.FlagHoistSub.prototype.getReplyChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.setReplyChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string flag_names = 5;
 * @return {!Array<string>}
 */
proto.flag_util.FlagHoistSub.prototype.getFlagNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.setFlagNamesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.addFlagNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flag_util.FlagHoistSub} returns this
 */
proto.flag_util.FlagHoistSub.prototype.clearFlagNamesList = function() {
  return this.setFlagNamesList([]);
};


goog.object.extend(exports, proto.flag_util);
